export const USER_LOGIN_REQUEST = "user/USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "user/USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "user/USER_LOGIN_FAIL";

export const USER_LOGOUT = "user/USER_LOGOUT";
